export default __webpack_public_path__ + "static/media/project_banner_kf.c74ad53d.png";